<form [formGroup]="form" class="card border-0">
  <div class="card-body">
    <div class="row">
      <div class="col-12 col-lg-4">
        <div class="d-flex flex-column gap-2">
          <p-multiSelect formControlName="users" [options]="listUsers" placeholder="Selecciona uno o más usuarios" scrollHeight="250px" display="chip" styleClass="w-100 h-50px" appendTo="body" />
          <small class="ps-2">Usuarios <span class="text-danger">Requerido *</span></small>
        </div>
      </div>

      <div class="col-12 col-lg-4 mb-3 mb-lg-0">
        <div class="d-flex flex-column gap-2">
          <p-multiSelect formControlName="modules" [options]="permissions" placeholder="Selecciona uno o más módulos" scrollHeight="250px" display="chip" styleClass="w-100 h-50px" appendTo="body" />
          <small class="ps-2">Selecciona un módulo para desactivar <span class="text-danger">Requerido *</span></small>
        </div>
      </div>
      <div class="col-12 col-lg-4 mb-3 mb-lg-0">
        <p-button severity="danger" label="Eliminar permisos" icon="pi pi-save" class="h-100" styleClass="h-50px" (click)="removeModuleUser()" [disabled]="!form.valid" />
      </div>
    </div>
  </div>
</form>
